import { AxiosResponse } from 'axios';
import { getMainAppDomain } from '../../utils/base-url';
import { Cookies } from '../cookies';

const STORAGE_AUTH_KEY = {
  AUTHORIZATION: 'authorization',
  REFRESH_TOKEN: 'x-refresh-token',
};

export class AccessToken {

  static setTokenFromHttpResponse(res: AxiosResponse) {
    if (res.headers['authorization']) {
      window.localStorage.setItem(STORAGE_AUTH_KEY.AUTHORIZATION, res.headers['authorization']);
    } else if (res.data?.access_token) {
      window.localStorage.setItem(STORAGE_AUTH_KEY.AUTHORIZATION, 'Bearer ' + res.data.access_token);
    }

    if (res.headers['x-refresh-token']) {
      window.localStorage.setItem(STORAGE_AUTH_KEY.REFRESH_TOKEN, res.headers['x-refresh-token']);
    } else if (res.data?.refresh_token) {
      window.localStorage.setItem(STORAGE_AUTH_KEY.REFRESH_TOKEN, res.data.refresh_token);
    }
  }

  /**
   * Set tokens to cookies for subdomain usage
   * This is used to set tokens before redirecting to a subdomain
   */
  static setTokensToCookies() {
    const authorization = this.getToken();
    if (authorization) {

      // document.cookie = token=abc123; Secure; SameSite=None; Domain=.example.com; Path=/
      Cookies.set(STORAGE_AUTH_KEY.AUTHORIZATION, authorization, { domain: getMainAppDomain() });
    }
    const refreshToken = this.getRefreshToken();
    if (refreshToken) {
      Cookies.set(STORAGE_AUTH_KEY.REFRESH_TOKEN, refreshToken, { domain: getMainAppDomain() });
    }
  }

  /**
   * Set tokens from cookies to local storage
   * This is used to set tokens from cookies after redirecting from a subdomain
   */
  static setTokensFromCookies() {
    const authorization = Cookies.get(STORAGE_AUTH_KEY.AUTHORIZATION);
    if (authorization) {
      window.localStorage.setItem(STORAGE_AUTH_KEY.AUTHORIZATION, authorization);
      Cookies.remove(STORAGE_AUTH_KEY.AUTHORIZATION, { domain: getMainAppDomain() });
    }
    const refreshToken = Cookies.get(STORAGE_AUTH_KEY.REFRESH_TOKEN);
    if (refreshToken) {
      window.localStorage.setItem(STORAGE_AUTH_KEY.REFRESH_TOKEN, refreshToken);
      Cookies.remove(STORAGE_AUTH_KEY.REFRESH_TOKEN, { domain: getMainAppDomain() });
    }
  }

  /**
   * @param {string} token 
   */
  static setToken(token: string) {
    window.localStorage.setItem(STORAGE_AUTH_KEY.AUTHORIZATION, token);
  }

  /**
   * Get token from local storage
   * @returns {string?}
   */
  static getToken() {
    // new token convention
    const authorization = window.localStorage.getItem(STORAGE_AUTH_KEY.AUTHORIZATION);
    if (authorization) return authorization;

    return null;
  }

  /**
   * Get refresh token from local storage
   * @returns {string?}
   */
  static getRefreshToken() {
    return window.localStorage.getItem(STORAGE_AUTH_KEY.REFRESH_TOKEN) || null;
  }

  static clearTokens() {
    window.localStorage.removeItem(STORAGE_AUTH_KEY.REFRESH_TOKEN);
    window.localStorage.removeItem(STORAGE_AUTH_KEY.AUTHORIZATION);
  }
}